module.exports = __webpack_public_path__ + "img/Oil.26aba8ab.svg";